import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import {
  Box,
  MobileStepper,
  Typography,
  Avatar,
  Grid,
  Button,
} from '@mui/material';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';

function SwipeableTestimonialCarousel() {
  const theme = useTheme();
  const fontSize = '16px';
  const [testimonials, setTestimonials] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [swiper, setSwiper] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/testimonials`)
      .then((response) => response.json())
      .then((data) => {
        setTestimonials(data);
      })
      .catch((error) => console.error('Error fetching testimonials:', error));
  }, []);

  const handleNext = () => {
    if (swiper) swiper.slideNext();
  };

  const handleBack = () => {
    if (swiper) swiper.slidePrev();
  };

  const handleSlideChange = () => {
    if (swiper && typeof swiper.realIndex === 'number') {
      setActiveStep(swiper.realIndex);
    } else {
      setActiveStep(0); // fallback to prevent NaN
    }
  };


  return (
    <Box bgcolor="white" py={2}>
      <Grid container direction="column" justifyContent="center" alignItems="center">
        <Box sx={{ width: '100%' }}>
          <Swiper
            onSwiper={setSwiper}
            onSlideChange={handleSlideChange}
            modules={[Autoplay, Navigation]}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            loop
            speed={500}
          >
            {testimonials.map((testimonial, index) => (
              <SwiperSlide key={index}>
                <Box sx={{ p: 2 }}>
                  <Box textAlign="center" mx={{ xs: '4%', md: '20%' }}>
                    <Typography
                      component="div"
                      sx={{ fontStyle: 'italic', fontSize }}
                    >
                      "{testimonial.quote}"
                    </Typography>
                  </Box>

                  <Box textAlign="center" pt={2}>
                    <Grid container direction="column" justifyContent="center" alignItems="center">
                      <Avatar
                        src={testimonial.avatar}
                        sx={{ width: 100, height: 100 }}
                      />
                    </Grid>
                  </Box>

                  <Box textAlign="center" sx={{ mt: 2 }}>
                    <Typography
                      component="div"
                      sx={{ fontWeight: 'bold', fontSize }}
                    >
                      {testimonial.author}
                    </Typography>
                  </Box>
                  <Box textAlign="center">
                    <Typography component="div" sx={{ fontSize }}>
                      {testimonial.title}
                    </Typography>
                  </Box>
                  <Box textAlign="center">
                    <Typography component="div" sx={{ fontSize }}>
                      {testimonial.school}
                    </Typography>
                  </Box>
                </Box>
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>

        <MobileStepper
          sx={{
            bgcolor: 'inherit',
            '& .MuiMobileStepper-dot': { backgroundColor: 'darkgray' },
            '& .MuiMobileStepper-dotActive': { backgroundColor: '#fecc00' },
          }}
          steps={Array.isArray(testimonials) ? testimonials.length : 0}
          position="static"
          activeStep={Number.isInteger(activeStep) ? activeStep : 0}  // failsafe fallback
          nextButton={
            <Button size="small" onClick={handleNext} sx={{ fontSize: '14px' }}>
              Next
              {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </Button>
          }
          backButton={
            <Button size="small" onClick={handleBack} sx={{ fontSize: '14px' }}>
              {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
              Back
            </Button>
          }
        />

      </Grid>
    </Box>
  );
}

export default SwipeableTestimonialCarousel;
